import React from "react";
import streakFireIcon from "../../../utilities/images/study_dashboard/streak_fire.png";
import streakFireEmptyIcon from "../../../utilities/images/study_dashboard/empty_states/streak_fire_empty.svg";
import streakArrowIcon from "../../../utilities/images/study_dashboard/streak_arrow.svg";
import "./DailyGoalStreakCard.css";

const DailyGoalStreakCard = ({
  streakDays = 0,
  streakLabel = "Daily Goal Streak",
  fireIconUrl,
  onOpenStreak,
}) => {
  const days = Number(streakDays) || 0;
  const isEmpty = days <= 0;

  if (isEmpty) {
    return (
      <article className="daily-goal-streak-card daily-goal-streak-card--empty">
        <div className="daily-goal-streak-card__empty-body">
          <div className="daily-goal-streak-card__fire-wrap" aria-hidden="true">
            <img
              src={streakFireEmptyIcon}
              alt=""
              className="daily-goal-streak-card__fire daily-goal-streak-card__fire--empty"
            />
          </div>
          <div className="daily-goal-streak-card__text">
            <p className="daily-goal-streak-card__empty-title">No streak yet!</p>
            <p className="daily-goal-streak-card__empty-description">
              Start learning today and build your streak.
            </p>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="daily-goal-streak-card">
      <div className="daily-goal-streak-card__content">
        <img
          src={fireIconUrl || streakFireIcon}
          alt=""
          className="daily-goal-streak-card__fire"
          aria-hidden="true"
        />
        <div className="daily-goal-streak-card__text">
          <p className="daily-goal-streak-card__days">{days} Day</p>
          <p className="daily-goal-streak-card__label">{streakLabel}</p>
        </div>
      </div>

      <button
        type="button"
        className="daily-goal-streak-card__action"
        aria-label="View streak details"
        onClick={onOpenStreak}
      >
        <img
          src={streakArrowIcon}
          alt=""
          className="daily-goal-streak-card__action-icon"
          aria-hidden="true"
        />
      </button>
    </article>
  );
};

export default DailyGoalStreakCard;
